export default "__VITE_ASSET__YgP5aYvF__"